import styled from 'styled-components';

import { Input as FormInput, INPUT_STYLES_MIXIN, InputTextIndicator, ErrorMessageText } from 'styles/form';
import { DatePickerWrapper, TimePickerWrapper } from 'components/DateTimePicker/styles';

export const EDITING_DISABLED_CLASS = 'editingDisabled';

export const FieldContainer = styled.div<{ visible?: boolean }>`
  transition: max-height 0.15s linear;
  text-align: left;

  ${ErrorMessageText} {
    position: relative;
    top: -2px;
  }
  ${(props) => props.visible === false && `display: none;`};
`;

export const FieldInputWrapper = styled.div`
  ${DatePickerWrapper}, ${TimePickerWrapper} {
    ${INPUT_STYLES_MIXIN};
    height: 30px;
    margin-top: 5px;
    input {
      margin: 0;
      height: 1em;
    }
  }
`;

export const FieldRow = styled.div`
  display: flex;
  justify-content: start;
  margin-bottom: 1em;
`;

export const FieldInput = styled(FormInput)<{ visible?: boolean }>`
  ${(props) => props.visible === false && `display: none;`} width: 100%;
  height: 30px;
`;

export const PhoneInput = styled(FieldInput)`
  width: calc(100% - 20px);
`;
